import 'react';
import { DisclaimerText, Link } from 'reaxl';
import { jsxs, jsx } from 'react/jsx-runtime';
function CustomDisclaimerText(_ref) {
  let {
    className
  } = _ref;
  return /*#__PURE__*/jsxs(DisclaimerText, {
    className: className,
    children: ["My Wallet is provided by Kelley Blue Book. Your My Wallet information will be used in accordance with the", ' ', /*#__PURE__*/jsx(Link, {
      href: "https://www.kbb.com/company/privacy-policy/",
      target: "_blank",
      rel: "noopener noreferrer",
      children: "Kelley Blue Book Privacy Statement."
    })]
  });
}
export { CustomDisclaimerText as default };
